import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "footer-buttons" }

import ButtonOutline from '@/design-system/atoms/buttons/ButtonOutline.vue'
import ModalBase from './ModalBase.vue'
import ButtonPrimary from '@/design-system/atoms/buttons/ButtonPrimary.vue'
import { onMounted, onUnmounted, ref, toRefs, watch } from 'vue'
import { useI18n } from 'vue-i18n'

type Props = {
  title: string
  submitButtonText?: string
  disableSubmit?: boolean
  open?: boolean
  icon?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleFormModal',
  props: {
    title: {},
    submitButtonText: { default: 'Submit' },
    disableSubmit: { type: Boolean, default: false },
    open: { type: Boolean, default: false },
    icon: { default: undefined }
  },
  emits: ["submit", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const { title, submitButtonText, disableSubmit } = toRefs(props)

const emit = __emit

const { t } = useI18n()

const isOpen = ref(props.open)

watch(
  () => props.open,
  (newValue) => {
    isOpen.value = newValue
  },
  { immediate: true }
)

onMounted(() => {
  window.addEventListener('keydown', handleKeydown)
})

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown)
})

const handleKeydown = (event: KeyboardEvent) => {
  if (!isOpen.value) return
  if (event.key === 'Enter') {
    submit()
  }
}

const closeModal = () => {
  isOpen.value = false
  emit('close')
}

const submit = () => {
  if (!disableSubmit.value) {
    isOpen.value = false
    emit('submit')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    title: _unref(title),
    open: isOpen.value,
    icon: _ctx.icon,
    onClose: closeModal
  }, {
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "content")
    ]),
    footer: _withCtx(() => [
      _renderSlot(_ctx.$slots, "footer"),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ButtonOutline, {
          buttonText: _unref(t)('general__text__cancel'),
          onOnClicked: closeModal
        }, null, 8, ["buttonText"]),
        _createVNode(ButtonPrimary, {
          buttonText: _unref(submitButtonText),
          disabled: _unref(disableSubmit),
          onOnClicked: submit
        }, null, 8, ["buttonText", "disabled"])
      ])
    ]),
    _: 3
  }, 8, ["title", "open", "icon"]))
}
}

})